import React, { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { LiaUserEditSolid } from "react-icons/lia";
import { FiShoppingCart } from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom"
import { withTranslation } from "react-i18next";
import { IoListOutline, IoHomeOutline } from "react-icons/io5";
import { PiNetworkLight } from "react-icons/pi";
import { TfiLayoutSliderAlt } from "react-icons/tfi";
import { FaLeanpub } from "react-icons/fa6";
import { TbChartBarPopular } from "react-icons/tb";
import { GrIndicator } from "react-icons/gr";
import { RiSurveyLine } from "react-icons/ri";
import { MdOutlineFeedback } from "react-icons/md";
import { VscFileSubmodule } from "react-icons/vsc";
import { LuGraduationCap } from "react-icons/lu";
import { FaUser } from "react-icons/fa";
import { CiUser } from "react-icons/ci";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { HiOutlineUsers } from "react-icons/hi";
import { SiLevelsdotfyi } from "react-icons/si";
import { GoTrophy } from "react-icons/go";
import { GrChapterAdd } from "react-icons/gr";
import { FiUsers } from "react-icons/fi";
import { PiChalkboardTeacher } from "react-icons/pi";
import { MdOutlineAssignment } from "react-icons/md";
import { FaRegCalendarCheck } from "react-icons/fa";
import { PiNotebookLight } from "react-icons/pi";
import { FaQuestionCircle } from "react-icons/fa";




const SidebarContent = ({ t }) => {
  const location = useLocation();
  const navigate = useNavigate()
  const ref = useRef();
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const user = useSelector(state => state?.Login.user)
  const path = location.pathname;
  const permissions = JSON.parse(localStorage.getItem('permissions'));
  if(permissions?.length == 0){
     navigate('/login')
  }
  

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); 
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; 
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); 
                parent5.childNodes[0].classList.remove("mm-active"); 
              }
            }
          }
        }
      }
    }
  };

  function tToggle2() {
    var body = document.body;
    if (window.screen.width <= 992) {
      body.classList.toggle("sidebar-enable");
    }
  }

  const activeMenu = useCallback(() => {
    const pathName = location.pathname;
    const fullPath = pathName;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  // Get available paths from permissions
  const availablePaths = permissions?.map(permission => permission.page_url);

  // Handle menu item click
  const handleMenuItemClick = (itemPath) => {
    setSelectedMenuItem(itemPath);  // Set the active menu item
  };

  const getActiveItemStyle = (itemPath) => {
    return selectedMenuItem === itemPath ? { backgroundColor: "#f0f0f0" } : {};
  };

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {availablePaths?.includes('/dashboard')&&(
              <li>
                <Link to="/dashboard" className="waves-effect" onClick={() => { handleMenuItemClick("/dashboard"); tToggle2(); }}>
                  <IoHomeOutline size={20} className="me-2 mb-1" />
                  <span className="">{t("Dashboard")}</span>
                </Link>
              </li>
            )}

            {availablePaths?.includes('/users') && <li>
              <Link to="/users" className="waves-effect" onClick={() => { handleMenuItemClick("/users"); tToggle2(); }}>
                <CiUser size={22} className="me-2 mb-1" />
                <span>{t("Users")}</span>
              </Link>
            </li>}

            {availablePaths?.includes('/students') && <li>
              <Link to="/students" className="waves-effect" onClick={() => { handleMenuItemClick("/students"); tToggle2(); }}>
                <FiUsers size={22} className="me-2 mb-1" />
                <span>{t("Students")}</span>
              </Link>
            </li>}
            {availablePaths?.includes('/tutors') && <li>
              <Link to="/tutors" className="waves-effect" onClick={() => { handleMenuItemClick("/tutors"); tToggle2(); }}>
                <PiChalkboardTeacher size={22} className="me-2 mb-1" />
                <span>{t("Tutors")}</span>
              </Link>
            </li>}
            {availablePaths?.includes('/courses') && <li>
              <Link to="/courses" className="waves-effect" onClick={() => { handleMenuItemClick("/courses"); tToggle2(); }}>
                <LuGraduationCap  size={22} className="me-2 mb-1" />
                <span>{t("Courses")}</span>
              </Link>
            </li>}
            {availablePaths?.includes('/modules') && <li>
              <Link to="/modules" className="waves-effect" onClick={() => { handleMenuItemClick("/modules"); tToggle2(); }}>
                <VscFileSubmodule  size={22} className="me-2 mb-1" />
                <span>{t("Modules")}</span>
              </Link>
            </li>}

            {availablePaths?.includes('/chapters') && <li>
              <Link to="/chapters" className="waves-effect" onClick={() => { handleMenuItemClick("/chapters"); tToggle2(); }}>
                <GrChapterAdd  size={22} className="me-2 mb-1" />
                <span>{t("Chapters")}</span>
              </Link>
            </li>}


                 {availablePaths?.includes('/lessons') && <li>
              <Link to="/lessons" className="waves-effect" onClick={() => { handleMenuItemClick("/lessons"); tToggle2(); }}>
                <PiNotebookLight size={22} className="me-2 mb-1" />
                <span>{t("Lessons")}</span>
              </Link>
            </li>}

                             {availablePaths?.includes('/lessons') && <li>
              <Link to="/attendance" className="waves-effect" onClick={() => { handleMenuItemClick("/attendance"); tToggle2(); }}>
                <FaRegCalendarCheck size={22} className="me-2 mb-1" />  
                <span>{t("Attendance")}</span>
              </Link>
            </li>}
 
                              {availablePaths?.includes('/assignments') && <li>
              <Link to="/assignments" className="waves-effect" onClick={() => { handleMenuItemClick("/assignments"); tToggle2(); }}>
               <MdOutlineAssignment size={22} className="me-2 mb-1" />
                <span>{t("Assignments")}</span>
              </Link>
            </li>}

            {availablePaths?.includes('/levels') && <li>
              <Link to="/levels" className="waves-effect" onClick={() => { handleMenuItemClick("/levels"); tToggle2(); }}>
              <SiLevelsdotfyi  size={22} className="me-2 mb-1" />
                <span>{t("Levels")}</span>
              </Link>
            </li>}

            {availablePaths?.includes('/rewards') && <li>
              <Link to="/rewards" className="waves-effect" onClick={() => { handleMenuItemClick("/rewards"); tToggle2(); }}>
              <GoTrophy  size={20} className="me-2 mb-1" />
                <span>{t("Rewards")}</span>
              </Link>
            </li>}

            {availablePaths?.includes('/customers') && <li>
              <Link to="/customers" className="waves-effect" onClick={() => { handleMenuItemClick("/customers"); tToggle2(); }}>
                <HiOutlineUsers size={20} className="me-2 mb-1" />
                <span>{t("Customers")}</span>
              </Link>
            </li>}

            {availablePaths?.includes('/roles')  && <li>
              <Link to="/roles" className="waves-effect" onClick={() => { handleMenuItemClick("/roles"); tToggle2(); }}>
                <LiaUserEditSolid size={22} className="me-2" />
                <span>{t("Roles")}</span>
              </Link>
            </li>}
                        {availablePaths?.includes('/questions-and-answers')  && <li>
              <Link to="/questions-and-answers" className="waves-effect" onClick={() => { handleMenuItemClick("/roles"); tToggle2(); }}>
               <FaQuestionCircle size={22} className="me-2 mb-1" />
                <span>{t("Questions & Answers")}</span>
              </Link>
            </li>}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  permissions: PropTypes.array,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
